// Centralized backend base URL.
//
// Default: derived from Vite's BASE_URL (set from `base` in vite.config.ts, itself
// driven by APP_BASE_PATH). Served under /llm-sizing-tool-fullscreen/, the browser
// then calls /llm-sizing-tool-fullscreen/api/..., which the upstream reverse proxy
// and the container's nginx (see nginx.conf.template) route to the backend; in dev
// the Vite proxy forwards it (see vite.config.ts). A root-relative "/api/..." would
// instead escape the subpath mount, so the prefix has to be carried explicitly.
// Set VITE_API_URL to call an absolute backend URL directly (bypasses the proxy).
export const API_BASE_URL =
  import.meta.env.VITE_API_URL ?? "https://lenovopress.lenovo.com/llm-sizing-tool-fullscreen/";
